import React from 'react';
import { Quote, Star, TrendingUp, Users, Shield, Award, Building2 } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Paulo Nabuco",
      role: "Diretor Operacional",
      company: "Parque das Rosas",
      image: "https://wcompass.com.br/img/paulo.jpg",
      quote: "Transformamos nossa operação. Reduzimos em 40% os conflitos com síndicos e melhoramos nossa segurança e o controle de autorizados. A validação NFC é simplesmente revolucionária.",
      rating: 5,
      metrics: {
        icon: TrendingUp,
        value: "40%",
        label: "Redução de conflitos"
      }
    },
    {
      name: "Georges Bitencourt",
      role: "CEO",
      company: "Ecobalsas",
      image: "https://wcompass.com.br/img/georges.jpg",
      quote: "A rastreabilidade completa nos permitiu comprovar 100% dos embarques. aumentamos a renovação de contratos este ano com a ajuda da tecnologia e da governança que o sistema oferece.",
      rating: 5,
      metrics: {
        icon: Shield,
        value: "100%",
        label: "Rastreabilidade"
      }
    }
  ];

  const caseStudies = [
    {
      icon: Users,
      company: "Condomínio Parque Imperial",
      passengers: "450+ passageiros",
      result: "Zero embarques não autorizados em 12 meses",
      improvement: "100% de satisfação dos moradores"
    },
    {
      icon: Building2,
      company: "Residencial Alphaville",
      passengers: "320+ passageiros",
      result: "Redução de 60% em reclamações",
      improvement: "Renovação automática do contrato"
    },
    {
      icon: Shield,
      company: "Green Valley Corporate",
      passengers: "580+ colaboradores",
      result: "Economia de R$ 18k/mês em custos operacionais",
      improvement: "Auditoria 100% aprovada"
    }
  ];

  const clients = [
    "Ecobalsas",
    "Parque das Rosas",
    "Prefeitura de Cabo Frio", 
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-20 w-96 h-96 bg-[#007bff] rounded-full mix-blend-multiply filter blur-3xl opacity-5"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-[#008080] rounded-full mix-blend-multiply filter blur-3xl opacity-5"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#008080]/10 px-4 py-2 rounded-full border border-[#008080]/20 mb-6">
            <Award className="w-4 h-4 text-[#008080]" />
            <span className="text-sm font-medium text-[#008080]">Prova Social</span>
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Cases de Sucesso
          </h2>
          <p className="text-xl text-gray-600">
            Empresas de transporte que escolheram governança e transformaram seus resultados
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-7xl mx-auto mb-20">
          {testimonials.map((testimonial, index) => {
            const MetricIcon = testimonial.metrics.icon;
            return (
              <div 
                key={index}
                className="group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-[#007bff] hover:-translate-y-2 relative overflow-hidden"
              >
                {/* Quote icon background */}
                <div className="absolute top-0 right-0 w-32 h-32 opacity-5">
                  <Quote className="w-full h-full text-[#007bff]" />
                </div>

                {/* Rating stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-[#FFD700] text-[#FFD700]" />
                  ))}
                </div>

                {/* Quote */}
                <blockquote className="text-gray-700 leading-relaxed mb-6 relative z-10">
                  "{testimonial.quote}"
                </blockquote>

                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 mt-6">
  
  {/* Metric badge */}
  <div className="bg-gradient-to-r from-[#007bff]/10 to-[#008080]/10 rounded-xl p-4 border border-[#007bff]/20">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 rounded-lg bg-[#007bff]/20 flex items-center justify-center">
        <MetricIcon className="w-5 h-5 text-[#007bff]" />
      </div>
      <div>
        <p className="text-2xl font-bold text-gray-900">
          {testimonial.metrics.value}
        </p>
        <p className="text-sm text-gray-600">
          {testimonial.metrics.label}
        </p>
      </div>
    </div>
  </div>

  {/* Author */}
  <div className="flex items-center gap-4">
    <img
      src={testimonial.image}
      alt={testimonial.name}
      className="w-14 h-14 rounded-full object-cover border-2 border-gray-200"
    />
    <div>
      <p className="font-bold text-gray-900">
        {testimonial.name}
      </p>
      <p className="text-sm text-gray-600">
        {testimonial.role}
      </p>
      <p className="text-sm text-[#007bff] font-medium">
        {testimonial.company}
      </p>
    </div>
  </div>

</div>

              </div>
            );
          })}
        </div>

        {/* Case Studies Cards 
        <div className="max-w-7xl mx-auto mb-16">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">
            Resultados Comprovados
          </h3>
          
          <div className="grid md:grid-cols-3 gap-6">
            {caseStudies.map((study, index) => {
              const Icon = study.icon;
              return (
                <div 
                  key={index}
                  className="bg-gradient-to-br from-[#007bff]/5 to-[#008080]/5 rounded-2xl p-8 border border-[#007bff]/20 hover:border-[#007bff] transition-all duration-300"
                >
                  <div className="w-14 h-14 rounded-xl bg-[#007bff]/20 flex items-center justify-center mb-6">
                    <Icon className="w-7 h-7 text-[#007bff]" />
                  </div>
                  
                  <h4 className="text-xl font-bold text-gray-900 mb-2">
                    {study.company}
                  </h4>
                  
                  <p className="text-[#008080] font-semibold mb-4">
                    {study.passengers}
                  </p>
                  
                  <div className="space-y-3">
                    <div className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#007bff] mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700 leading-relaxed">{study.result}</p>
                    </div>
                    
                    <div className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 rounded-full bg-[#008080] mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700 leading-relaxed">{study.improvement}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>*/}

        {/* Client Logos */}
        <div className="max-w-5xl mx-auto">
          <p className="text-center text-gray-600 mb-8 text-lg">
            Empresas que confiam no WCOMPass
          </p>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6 justify-items-center">
          {clients.map((client, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center border border-gray-100 hover:border-[#007bff] group"
              >
                <p className="text-gray-700 font-semibold text-center text-sm group-hover:text-[#007bff] transition-colors">
                  {client}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Stats Bar */}
        <div className="max-w-5xl mx-auto mt-16">
          <div className="bg-gradient-to-r from-[#007bff] to-[#008080] rounded-3xl p-10 shadow-2xl">
            <div className="grid md:grid-cols-4 gap-8 text-white text-center">
              <div>
                <p className="text-5xl font-bold mb-2">1.000+</p>
                <p className="text-white/90 text-lg">Passageiros Ativos</p>
              </div>
              <div>
                <p className="text-5xl font-bold mb-2">15+</p>
                <p className="text-white/90 text-lg">Empresas Parceiras</p>
              </div>
              <div>
                <p className="text-5xl font-bold mb-2">100%</p>
                <p className="text-white/90 text-lg">Rastreabilidade</p>
              </div>
              <div>
                <p className="text-5xl font-bold mb-2">98%</p>
                <p className="text-white/90 text-lg">Satisfação</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
